module.exports = __webpack_public_path__ + "assets/img/chx_d_3.f929d815.png";